<template>
  <div :class="['height-20', { 'reg-form__checkbox': noMargins }]">
    <label :class="['check', { 'check-align': checkAlign }]">
      <input
        v-model="checkedVal"
        v-bind="$attrs"
        class="check__input"
        type="checkbox"
      >
      <v-icon
        :name="stateCheckbox"
        width="16"
        height="16"
        stroke="none"
        action-color="none"
        pointer
      />
      <span class="caption">
        <slot>
          {{ title }}
        </slot>
      </span>
    </label>
  </div>
</template>
<script setup>
import { computed } from "vue";
// eslint-disable-next-line no-undef
const props = defineProps({
  modelValue: {
    type: [Boolean, String],
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  checkAlign: {
    type: Boolean,
    default: () => false,
  },
  noMargins: {
    type: Boolean,
    default: () => false,
  },
  hasFlex: {
    type: Boolean,
    default: () => false,
  },
});

// eslint-disable-next-line no-undef
const emit = defineEmits({
  "update:modelValue": null,
});
const checkedVal = computed({
  get() {
    return props.modelValue;
  },
  set(passVal) {
    emit("update:modelValue", passVal);
  },
});
const stateCheckbox = computed(() => {
  if (typeof checkedVal.value === "string") {
    return checkedVal.value == "yes" ? "checked" : "un-checked";
  }
  return checkedVal.value ? "checked" : "un-checked";
});
</script>

<style lang="scss" scoped>
.check {
  /* padding-left: 27px; */
  display: inline-flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  cursor: pointer;
  color: #595a5b;

  &__input {
    position: absolute;
    left: -999px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
}
.caption {
  padding-left: 8px;
  display: block;
  width: 100%;
}
.check-align {
  justify-content: flex-start;
  align-items: flex-start;
}
.reg-form {
  &__checkbox {
    /* width: 16px; */
    height: 16px;
  }
  &__flex {
    display: flex;
    align-items: center;
  }
}
.height-20 {
  height: 20px;
  display: flex;
  align-items: center;
}
</style>
